<div class="cd-card">
  <div class="cd-card-header">
    <div class="cd-header-content">
      <mat-icon>pending_actions</mat-icon>
      <h2>Meeting Requests</h2>
    </div>
  </div>

  <div class="cd-requests-container">
    @for (m of pendingRequests; track m.id) {
      <div
        class="cd-request-card"
        [class.cd-request-focused]="m.id === focusedId"
        [attr.data-testid]="'request-card-' + m.id"
      >
        <div class="cd-request-info">
          <span
            class="cd-request-type"
            [class.cd-change-request]="m.isChangeRequest"
            [class.cd-changes-accepted]="!m.isChangeRequest && m.changesAccepted"
          >
            @if (isAwaitingMe(m)) {
              <span
                class="needs-attention-dot"
                [attr.data-testid]="'needs-attention-' + m.id"
              ></span>
            }
            {{
              m.isChangeRequest
                ? 'Proposed Changes'
                : m.changesAccepted
                  ? 'Student Accepted Your Changes'
                  : 'New Request'
            }}
          </span>
          <div class="cd-request-header">
            <span class="cd-student">{{ m.studentName }} • Grade {{ m.gradeLevel }}</span>
          </div>

          <div class="cd-meeting-details">
            <span class="cd-topic">{{ m.title }}</span>
            @if (m.description) {
              <span class="cd-description">{{ m.description }}</span>
            }
          </div>

          @if (m.isChangeRequest) {
            <div class="cd-meeting-time cd-meeting-time-original">
              <mat-icon aria-hidden="true">event_busy</mat-icon>
              <span>Currently {{ m.start | date: 'EEEE MMM d • h:mm a' }} • {{ m.location }}</span>
            </div>
            <div class="cd-meeting-time">
              <mat-icon aria-hidden="true">schedule</mat-icon>
              <span
                >Proposed {{ m.proposedStart | date: 'EEEE MMM d • h:mm a' }} •
                {{ m.requestedChanges?.duration }} mins
                @if (m.proposedLocation) {
                  • {{ m.proposedLocation }}
                }
              </span>
            </div>
            @if (m.proposedMessage) {
              <div class="cd-meeting-time">
                <mat-icon aria-hidden="true">notes</mat-icon>
                <span>{{ m.proposedMessage }}</span>
              </div>
            }
          } @else {
            <div class="cd-meeting-time">
              <mat-icon aria-hidden="true">schedule</mat-icon>
              <span>{{ m.start | date: 'EEEE MMM d • h:mm a' }} • {{ m.duration }} mins</span>
            </div>
          }
        </div>
        <div class="cd-request-actions">
          @if (isAwaitingMe(m)) {
            <button
              [attr.data-testid]="'confirm-request-btn-' + m.id"
              matButton="elevated"
              class="cd-action"
              id="confirm"
              [disabled]="processingIds.has(m.id)"
              (click)="confirm(m)"
            >
              CONFIRM
            </button>
            <button
              [attr.data-testid]="'propose-changes-btn-' + m.id"
              matButton
              class="cd-action"
              id="propose"
              [disabled]="processingIds.has(m.id)"
              (click)="proposeChanges(m)"
            >
              PROPOSE CHANGES
            </button>
            <button
              [attr.data-testid]="'deny-request-btn-' + m.id"
              matButton
              class="cd-action"
              id="deny"
              [disabled]="processingIds.has(m.id)"
              (click)="deny(m)"
            >
              DENY
            </button>
          } @else {
            <span class="cd-awaiting-student" [attr.data-testid]="'awaiting-student-' + m.id">
              <mat-icon aria-hidden="true">hourglass_empty</mat-icon>
              Awaiting student response
            </span>
          }
        </div>
      </div>
    } @empty {
      <div class="cd-emtpy-state" data-testid="pending-requests-empty">
        <p>🎉 All caught up! No pending requests.</p>
      </div>
    }
  </div>
</div>
